import { render, staticRenderFns } from "./base-nav.vue?vue&type=template&id=683ef28b"
import script from "./base-nav.vue?vue&type=script&lang=js"
export * from "./base-nav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports